const KEY = 'visibleViewNames';
export const setVisibleViewNames = (value: boolean) => sessionStorage.setItem(KEY, value ? 'true' : '');
export const getVisibleViewNames = () => !!sessionStorage.getItem(KEY);
